import { createAction, props } from "@ngrx/store";
import { IBrand } from "../models/brands.models";
import { IPageCount } from "src/app/shared/models/page.model";
import { APIResponse } from "src/app/core/models/api-response";

// fetch all brands
export const FetchAllBrands = createAction(
  '[ Brands ] - FetchAllBrands',
  props<{ includes?: Array<string> }>()
);
export const FetchAllBrandsSuccess = createAction(
  '[ Brands ] - FetchAllBrands Success ',
  props<{ brands: IBrand[]}>()
);
export const FetchAllBrandsError = createAction(
  '[ Brands ] - FetchAllBrand Error',
);

// fetch brands
export const FetchBrands = createAction(
  '[ Brands ] - FetchBrands',
  props<{ page: IPageCount; key?: string | undefined; append?: boolean }>()
);
export const FetchBrandsSuccess = createAction(
  '[ Brands ] - FetchBrands Success ',
  props<{ brands: APIResponse<IBrand>; append?: boolean }>()
);
export const FetchBrandsError = createAction(
  '[ Brands ] - FetchBrand Error',
);

// add brand
export const AddBrand = createAction(
  '[ Brand ] - AddBrand',
  props<{ brand: Omit<IBrand, 'id'> }>()
);
export const AddBrandSuccess = createAction(
  '[ Brand ] - AddBrand Success ',
  props<{ brand: IBrand }>()
);
export const AddBrandError = createAction(
  '[ Brand ] - AddBrand Error',
);

// Update brand
export const UpdateBrand = createAction(
  '[ Brand ] - UpdateBrand',
  props<{ id: number, brand: Omit<IBrand, 'id'> }>()
);
export const UpdateBrandSuccess = createAction(
  '[ Brand ] - UpdateBrand Success ',
  props<{ brand: IBrand }>()
);
export const UpdateBrandError = createAction(
  '[ Brand ] - UpdateBrand Error',
);

// Delete brand
export const DeleteBrand = createAction(
  '[ Brand ] - DeleteBrand',
  props<{ id: number }>()
);
export const DeleteBrandSuccess = createAction(
  '[ Brand ] - DeleteBrand Success ',
);
export const DeleteBrandError = createAction(
  '[ Brand ] - DeleteBrand Error',
);

//loader actions
export const SetBrandsLoader = createAction(
  '[ Brands ] - SetLoading',
  props<{ isLoading: boolean }>()
);

// search
export const SetBrandSearch = createAction( 
  '[ Brands ] - SetSearch',
  props<{ keyword: string }>()
);